import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import DateSelector from 'components/molecules/dateSelector/range';
import useOutsideClick from 'utils/useOutsideClick';
import common from 'constants/common';
import format from 'date-fns/format';

const DatePicker = ({ value, defaultValue, valueChanged }) => {
  const [showDateSelector, setShowDateSelector] = useState(false);
  const onSelect = (date) => {
    valueChanged(
      date ? format(new Date(date), common.dateFormats.birthDate) : date,
    );
    setShowDateSelector(false);
  };
  const ref = useRef();
  useOutsideClick(ref, () => {
    setShowDateSelector(false);
  });
  return (
    <div ref={ref}>
      <div
        onClick={() => {
          setShowDateSelector(true);
        }}
      >
        <Input
          className="main-field-input"
          value={value}
          defaultValue={defaultValue}
          onChange={(e) => {
            valueChanged(e.target.value);
          }}
        />
      </div>
      {showDateSelector && (
        <div className="datepicker">
          <DateSelector inDate={value} onSelect={onSelect} />
        </div>
      )}
    </div>
  );
};

DatePicker.propTypes = {
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  valueChanged: PropTypes.func,
};

export default DatePicker;
